import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 5a2 2 0 0 0 -2 2v10a2 2 0 0 1 -2 2","key":"svg-0"}],["path",{"d":"M3 17h4v4h-4l0 -4","key":"svg-1"}],["path",{"d":"M17 3h4v4h-4l0 -4","key":"svg-2"}]]

const IconRouteSquare2 = createReactComponent('outline', 'route-square-2', 'RouteSquare2', __iconNode);

export default IconRouteSquare2;